import { TextField as MuiTextField, TextFieldProps } from '@mui/material';


type Props = Omit<TextFieldProps, 'variant' | 'error'> & {
  error?: string,
  readOnly?: boolean
}

export default function TextArea({ error, ...other }: Props) {

  return (
      <MuiTextField {...other} error={!!error} multiline={true}
           InputLabelProps={{
            shrink: true,
          }}
      />
  );
}
